const layout = {
  spacing: '15px',
  responsive: {
    extraSmall: {
      type: 'max-width',
      unit: '576px',
    },
    small: {
      type: 'min-width',
      unit: '576px',
    },
    medium: {
      type: 'min-width',
      unit: '768px',
    },
    large: {
      type: 'min-width',
      unit: '992px',
    },
    extraLarge: {
      type: 'min-width',
      unit: '1200px',
    },
  },
  content: {
    width: '100%',
    padding: '25px 50px',
    color: '#607389',
  },
  header: {
    height: '80px',
    width: '1200px',
    form: {
      button: {
        background: '#607389',
      },
    },
    menuIcon: {
      color: '#424a59',
    },
    public: {
      color: '#ffffff',
    },
  },
  subheader: {
    height: '70px',
    background: '#424a5a',
    profile: {
      background: '#384050',
    },
    button: {
      background: '#618BBD',
    },
  },
  sidebar: {
    width: '260px',
    background: '#313949',
    padding: '20px',
    item: {
      active: {
        color: '#618abd',
      },
    },
    count: {
      background: '#28ab8c',
    },
  },
  form: {
    input: {
      height: '40px',
      padding: '0px 20px',
      border: {
        color: '#d9d9d9',
      },
      fontSize: '14px',
      fontWeight: 500,
      color: '#515c6a',
      success: {
        color: '#4A90E2', // done
      },
      error: {
        color: '#D0021B', // done
        fontSize: '14px',
      },
      focus: {
        border: {
          color: '#0070F9',
        },
        placeholder: {
          color: '#0070F9',
        },
      },
      placeholder: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#b5b5b5',
      },
      icon: {
        color: '#000000', // done
        fontSize: '20px',
      },
    },
  },
  button: {
    padding: '10px 25px',
    fontSize: '15px',
    fontWeight: 300,
    spacer: {
      width: '5px',
    },
    save: {
      color: '#618bbd',
    },
    edit: {
      color: '#898989',
    },
  },
  card: {
    green: '#00A651', // done
    blue: '#4A90E2', // done
    orange: '#fcb900', // done
    red: '#D0021B', // done
    yellow: '#F5A623', // done
    gray: '#bdbdbd', // done
    avatar: {
      textColorGreen: '#73d68d', // done
      textColorBlue: '#70b3cc', // done
      textColorOrange: '#efcd70', // done
      textColorRed: '#F18D8D', // done
    },
    containerPadding: '10px 16px 10px',
    topHeight: '7px',
    topHeightWithIcon: '35px',
    bottomPadding: '10px',
    bottomMaxHeight: '38px',
    containerHeight: '164px',
    link: {
      color: '#607389',
    },
  },
  tag: {
    item: {
      border: {
        color: '#BABABA',
        width: '1px',
        radius: '20px',
      },
      margin: '4px',
      width: '100px',
    },
    text: {
      color: '#FFFFFF',
      margin: '5px 10px',
      fontSize: '14px',
    },
    background: {
      color: '#618BBD',
    },
    closeButton: {
      background: {
        color: '#416795',
      },
    },
  },
  icon: {
    color: '#FFFFFF',
    fontSize: '14px',
    defaultColor: '#757575',
  },
  alert: {
    background: {
      warning: '#fff3cd',
      info: '#d1ecf1',
      success: '#d4edda',
      danger: '#f8d7da',
    },
    color: {
      warning: '#856404',
      info: '#0c5460',
      success: '#155724',
      danger: '#721c24',
    },
  },
  dropdown: {
    label: {
      backgroundColor: '#f9f9f9',
    },
    check: {
      selectedBackgroundColor: '#f9f9f9',
    },
    color: '#232323',
    li: {
      hoverBackgroundColor: '#f9f9f9',
      hoverColor: '#232323',
      backgroundColor: '#f9f9f9',
    },
    item: {
      backgroundColor: '#f9f9f9',
      color: 'black',
      hoverColor: '#e5e5e5',
    },
  },
  search: {
    body: {
      color: '#f6f6f6',
    },
    card: {
      button: {
        color: '#309dd1',
      },
    },
    input: {
      height: '40px',
      padding: '0px 20px',
      border: {
        color: '#d9d9d9',
      },
      fontSize: '14px',
      fontWeight: 500,
      color: '#f6f6f6',
      focus: {
        border: {
          color: '#c9c9c9',
        },
      },
      placeholder: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#b5b5b5',
      },
    },
  },
  text: {
    info: {
      color: '#607389',
    },
  },
};

export default layout;
